module.exports = __webpack_public_path__ + "img/portadafacturacion.b9523e3b.jpg";